import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { EmailInput } from 'page/ProfileScreen/Email/EmailInput'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const EmailStep = observer(() => {
  const onCancel = useLatestCallback(async () => {
    store.profile.step = 'profile'
  })

  const onSave = useLatestCallback(() => {
    if (!store.profile.email.check()) return
    controller.saveProfileEmail()
    controller.closeProfile()
  })

  const onHide = useLatestCallback(() => {
    controller.hideProfile()
  })

  const onContinue = useLatestCallback(() => {
    controller.closeProfile()
  })

  return <Banner title={i18n('ReceiveYourOutfitsByEmail')} onCancel={onCancel}>
    <Typo size={14} secondary>{i18n('WeWillNotSendSpamOrTransferYourDataToThirdParties')}</Typo>
    <Gap height={24} />
    <EmailInput it={store.profile.email} />
    <Gap height={24} />
    <Button large primary action={onSave}>
      {i18n('SaveAndContinue')}
    </Button>
    <Gap height={12} />
    <Button large text action={onHide}>
      {i18n('DontShowAgain')}
    </Button>
    <Gap height={12} />
    <Button large link={!opt.tsum} action={onContinue}>
      {i18n('ContinueWithoutEmail')}
    </Button>
  </Banner>
})
